import { Box, Card } from "@mui/material";
import React, { useContext } from "react";
import { ConfigOperationsContext } from ".";
import PointPreview from "./PointPreview";
import PointAddNew from "./PointAddNew";
import PointEdit from "./PointEdit";
import { blue } from "@mui/material/colors";

function ConfigOperations() {
  const { display, operation } = useContext(ConfigOperationsContext);
  //const theme = useTheme()
  return (
    <Card
      elevation={24}
      //variant="outlined"
      sx={{
        minWidth: 450,
        maxWidth: 450,
        borderLeft: 0,
        borderTop: 0,
        borderBottom: 0,
        borderRadius: 0,
        overflow: "hidden",
        position: "relative",
        display,        
        backgroundColor:blue[50]
        //background:'rgb(255,255,255)',
        //background:'linear-gradient(180deg, rgba(255,255,255,1) 0%,rgba(255,255,255,1) 80%, rgb(181, 203, 238) 100%)'
      }}
    >
      
      <Box sx={{ minHeight: "calc(100%)"}}>      
        {operation === 1 && <PointPreview />}
        {operation === 2 && <PointAddNew />}
        {operation === 3 && <PointEdit />}
      </Box>
    </Card>
  );
}

export default ConfigOperations;
